import { Component, computed, input, linkedSignal, output, WritableSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TaskType } from '@app/shared/types/models/task/task-type.model';
import { UiSelectComponent } from '@app/shared/ui/select/ui-select.component';
import { ProffeoUiSelectOption } from '@app/shared/ui/types/select.types';

@Component({
  selector: 'proffeo-task-type-select',
  imports: [MatIconModule, UiSelectComponent],
  templateUrl: './task-type-select.component.html'
})
export class TaskTypeSelectComponent {
  protected readonly selectedTaskType: WritableSignal<TaskType> = linkedSignal(() => this.activeTaskType());

  protected readonly typeOptions = computed((): ProffeoUiSelectOption<TaskType>[] =>
    this.taskTypes().map(type => ({
      value: type,
      label: type.name ?? ''
    }))
  );

  public readonly taskTypeSelected = output<TaskType>();
  public readonly taskTypes = input<TaskType[]>([]);
  public readonly activeTaskType = input<TaskType>(this.taskTypes()[0]);
  public readonly small = input<boolean>(false);
  public readonly readonly = input<boolean>(true);
  public readonly taskNumber = input<string>('');

  protected compareTaskTypes(first: TaskType, second: TaskType): boolean {
    return first === second;
  }

  protected onTaskTypeChange(taskType: TaskType | TaskType[] | null): void {
    if (taskType === null || Array.isArray(taskType) || taskType === this.selectedTaskType()) {
      return;
    }

    this.selectedTaskType.set(taskType);
    this.taskTypeSelected.emit(taskType);
  }
}
